const extraOptions = [
  {
    "model": "spare-wheel",
    "price": 110,
    "img": "images/extra-options-2025/Spare wheel.jpg",
    "imgAlt": "spare-wheel",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "lifting-lugs",
    "price": 25,
    "img": "images/extra-options-2025/Lifting_lug.jpg",
    "imgAlt": "lifting-lugs",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "lifting-leg",
    "price": 75,
    "img": "images/extra-options-2025/Lifting_leg_1300kg.jpg",
    "imgAlt": "lifting-leg",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "quick-lock-system",
    "price": 40,
    "img": "images/extra-options-2025/Quick Lock System.jpg",
    "imgAlt": "quick-lock-system",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "heavy-duty-leg",
    "price": 600,
    "img": "images/extra-options-2025/Heavy Duty Legs 3000kg.jpg",
    "imgAlt": "heavy-duty-leg",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "stabilizier-triangle",
    "price": 45,
    "img": "images/extra-options-2025/Stabilizer triangle.jpg",
    "imgAlt": "stabilizier-triangle",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "jockey-wheel",
    "price": 55,
    "img": "images/extra-options-2025/Jockey_wheel.jpg",
    "imgAlt": "jockey-wheel",
    "multilingualName": true,
    "isSquareImage": true
  },
];


export default extraOptions;
